'use client';

import { c as _c } from "react/compiler-runtime";
import { useCouponId, useCouponIndices, useHasHydratedCouponStore } from '@svs/nova-poolbetting/core/frameworks/nextjs/coupon';
import type { PropsWithChildren, ReactNode } from 'react';
import { CouponScrollbarHeightProvider } from '@/components/index.browser';
import CouponFallback from './CouponFallback';
type CouponWrapperProps = PropsWithChildren;

/**
 * Component responsible for wrapping the Coupon component and ensuring that the coupon store has hydrated before rendering the Coupon.
 *
 * @param root0 props
 * @param root0.children children components to render inside the wrapper if store has hydrated
 * @returns renders the Coupon component if the store has hydrated, otherwise renders a loading state
 */
export function CouponWrapper(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const hasHydrated = useHasHydratedCouponStore();
  const [couponId] = useCouponId();
  let t1;
  if ($[0] !== couponId) {
    t1 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const couponIndices = useCouponIndices(t1);
  if (!hasHydrated) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <CouponFallback />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const t2 = couponIndices.length > 1 ? "bg-layer-neutral lg:bg-surface-base p-1 lg:p-0" : "";
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <CouponScrollbarHeightProvider className={t2}>{children}</CouponScrollbarHeightProvider>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}